import React from 'react';

export const MobileMenu = ({ isOpen, onClose }) => {
  const menuItems = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Programs', href: '#programs' },
    { label: 'Impact', href: '#impact' },
    { label: 'Get Involved', href: '#get-involved' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <div
      className={`fixed inset-0 bg-[#231F20] z-40 transition-transform duration-300 ease-in-out ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      <nav className="flex flex-col items-center justify-center h-full px-8">
        {menuItems.map((item, index) => (
          <a
            key={item.label}
            href={item.href}
            className="text-white text-3xl font-semibold py-4 hover:text-[#5FC5B8] transition-colors duration-200"
            style={{
              animation: isOpen
                ? `slideIn 0.3s ease-out ${index * 0.1}s forwards`
                : 'none',
              opacity: isOpen ? 1 : 0,
            }}
          >
            {item.label}
          </a>
        ))}
      </nav>
    </div>
  );
};